import { css } from 'lit-element';

// the following was pulled from https://xds.cloud.capitalone.com/xds-styles/1.0.0/dist/xds-styles.min.css
export const XdsStylesButton = css`
  html {
    box-sizing: border-box;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  html,
  s,
  form {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  @font-face {
    font-family: 'Optimist';
    src: url('fonts/Optimist_W_XLt.woff2') format('woff2'),
      url('fonts/Optimist_W_XLt.woff') format('woff');
    font-weight: 200;
    font-style: normal;
  }
  @font-face {
    font-family: 'Optimist';
    src: url('fonts/Optimist_W_Lt.woff2') format('woff2'),
      url('fonts/Optimist_W_Lt.woff') format('woff');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Optimist';
    src: url('fonts/Optimist_W_Rg.woff2') format('woff2'),
      url('fonts/Optimist_W_Rg.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Optimist';
    src: url('fonts/Optimist_W_It.woff2') format('woff2'),
      url('fonts/Optimist_W_It.woff') format('woff');
    font-weight: 400;
    font-style: italic;
  }
  @font-face {
    font-family: 'Optimist';
    src: url('fonts/Optimist_W_SBd.woff2') format('woff2'),
      url('fonts/Optimist_W_SBd.woff') format('woff');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'Optimist';
    src: url('fonts/Optimist_W_Bd.woff2') format('woff2'),
      url('fonts/Optimist_W_Bd.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  }
  @keyframes scaleButton {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.95);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes toggleOff {
    from {
      right: 0%;
    }
    to {
      right: 40%;
    }
  }
  @keyframes toggleOn {
    from {
      right: 40%;
    }
    to {
      right: 0%;
    }
  }
  @keyframes zoomSpin {
    from {
      transform: rotate(0deg) scale(1.1);
    }
    to {
      transform: rotate(360deg) scale(1.1);
    }
  }
  @keyframes load-in {
    0% {
      transform: scale(0);
      -ms-transform: scale(0);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      -ms-transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
      -ms-transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
      -ms-transform: rotate(360deg);
    }
  }
  button {
    color: #3459a7;
    font-family: \"Optimist\",-apple-system,system-ui,BlinkMacSystemFont,\"Segoe UI\",Roboto,Ubuntu,sans-serif;
    font-size: 1rem;
    line-height: 1.5em;
    padding: 0.375rem 1rem;
    margin: 0;
    border: 2px solid transparent;
    border-color: #3459a7;
    border-radius: 4px;
    box-sizing: border-box;
    display: inline-block;
    cursor: pointer;
    background-color: transparent;
    transition: border-color 0.2s, background-color 0.2s, color 0.2s;
  }
  button:active,
  button:focus {
    animation: scaleButton 0.2s 1;
  }
  button:hover {
    text-decoration: none;
    color: #1f3564;
  }
  button.disabled,
  button[disabled] {
    cursor: pointer;
    text-decoration: none;
    opacity: 0.7;
    cursor: not-allowed;
  }

  .xds-button.default .xds-spinner::after,
  .xds-button.destructive .xds-spinner::after,
  .xds-button.regressive .xds-spinner::after {
    border: 2px solid #fff;
    border-top: 2px solid rgba(255, 255, 255, 0.25);
  }
  .xds-button.default .xds-spinner.align-left,
  .xds-button.destructive .xds-spinner.align-left,
  .xds-button.regressive .xds-spinner.align-left {
    margin-right: 0.3rem;
  }
  .xds-button.default .xds-spinner.align-right,
  .xds-button.destructive .xds-spinner.align-right,
  .xds-button.regressive .xds-spinner.align-right {
    margin-left: 0.3rem;
  }
  .xds-button.default.secondary .xds-spinner::after {
    border: 2px solid #3459a7;
    border-top: 2px solid rgba(52, 89, 167, 0.25);
  }
  .xds-button.regressive.secondary .xds-spinner::after {
    border: 2px solid #515252;
    border-top: 2px solid rgba(81, 82, 82, 0.25);
  }
  .xds-button-group button,
  .xds-button-group .xds-button {
    margin: 0 0.75rem 1rem 0;
  }
  .xds-button-group button:last-child,
  .xds-button-group .xds-button:last-child {
    margin: 0 0 1rem 0;
  }
  button,
  .xds-button {
    color: #3459a7;
    font-family: 'Optimist', -apple-system, system-ui, BlinkMacSystemFont,
      'Segoe UI', Roboto, Ubuntu, sans-serif;
    font-size: 1rem;
    line-height: 1.5em;
    padding: 0.375rem 1rem;
    margin: 0;
    border: 2px solid transparent;
    border-radius: 4px;
    box-sizing: border-box;
    display: inline-block;
    cursor: pointer;
    background-color: transparent;
    transition: border-color 0.2s, background-color 0.2s, color 0.2s;
  }
  button:active,
  button:focus,
  .xds-button:active,
  .xds-button:focus {
    animation: scaleButton 0.2s 1;
  }
  button:hover,
  .xds-button:hover {
    text-decoration: none;
    color: #1f3564;
  }
  button.inverse,
  .xds-button.inverse {
    color: #fff;
    background: transparent;
  }
  button.inverse .xds-icon,
  .xds-button.inverse .xds-icon {
    color: #fff;
  }
  button.inverse:hover,
  .xds-button.inverse:hover {
    color: #1f3564;
    background-color: #fff;
  }
  button.inverse:hover .xds-icon,
  .xds-button.inverse:hover .xds-icon {
    color: #1f3564;
  }
  button.disabled,
  button[disabled],
  .xds-button.disabled,
  .xds-button[disabled] {
    cursor: pointer;
    text-decoration: none;
    opacity: 0.7;
    cursor: not-allowed;
  }
  button.disabled:hover .xds-icon,
  button[disabled]:hover .xds-icon,
  .xds-button.disabled:hover .xds-icon,
  .xds-button[disabled]:hover .xds-icon {
    color: #3459a7;
  }
  button .xds-icon,
  .xds-button .xds-icon {
    color: #fff;
  }
  button.has-icon .xds-icon,
  .xds-button.has-icon .xds-icon {
    position: relative;
    top: 0;
    width: 1em;
    height: 1em;
  }
  button.has-icon.align-left .xds-icon,
  .xds-button.has-icon.align-left .xds-icon {
    margin-right: 0.625rem;
  }
  button.has-icon.align-right .xds-icon,
  .xds-button.has-icon.align-right .xds-icon {
    margin-left: 0.625rem;
  }
  button.icon-only,
  .xds-button.icon-only {
    padding: 0;
    line-height: 0;
    border-width: 0;
  }
  button.icon-only:focus,
  .xds-button.icon-only:focus {
    outline: none;
  }
  button.icon-only .xds-icon,
  .xds-button.icon-only .xds-icon {
    color: currentColor;
  }
  button.icon-only .xds-icon,
  .xds-button.icon-only .xds-icon {
    color: #3459a7;
    position: relative;
  }
  button.icon-only .xds-icon.align-left,
  .xds-button.icon-only .xds-icon.align-left {
    margin-right: 0.5rem;
  }
  button.icon-only .xds-icon.align-right,
  .xds-button.icon-only .xds-icon.align-right {
    margin-left: 0.5rem;
  }
  button.icon-only .xds-icon:hover,
  .xds-button.icon-only .xds-icon:hover {
    color: #1f3564;
  }
  button.default,
  .xds-button.default {
    background-color: #3459a7;
    border-color: #3459a7;
    color: #fff;
  }
  button.default:hover,
  .xds-button.default:hover {
    background-color: #1f3564;
    border-color: #1f3564;
    color: #fff;
    text-decoration: none;
  }
  button.default.disabled,
  button.default[disabled],
  button.default.btn-spinner,
  .xds-button.default.disabled,
  .xds-button.default[disabled],
  .xds-button.default.btn-spinner {
    background-color: #3459a7;
    border-color: #3459a7;
    color: #fff;
  }
  button.default.inverse,
  .xds-button.default.inverse {
    color: #3459a7;
    background-color: #fff;
    border-color: #fff;
  }
  button.default.inverse:hover,
  .xds-button.default.inverse:hover {
    color: #fff;
    background-color: #486ab0;
    border-color: #486ab0;
  }
  button.default.secondary,
  .xds-button.default.secondary {
    background-color: #fff;
    border-color: #3459a7;
    color: #3459a7;
  }
  button.default.secondary .xds-icon,
  .xds-button.default.secondary .xds-icon {
    color: #3459a7;
  }
  button.default.secondary:hover,
  .xds-button.default.secondary:hover {
    background-color: #1f3564;
    border-color: #1f3564;
    color: #fff;
    text-decoration: none;
  }
  button.default.secondary:hover .xds-icon,
  .xds-button.default.secondary:hover .xds-icon {
    color: #fff;
  }
  button.default.secondary.disabled,
  button.default.secondary[disabled],
  button.default.secondary.btn-spinner,
  .xds-button.default.secondary.disabled,
  .xds-button.default.secondary[disabled],
  .xds-button.default.secondary.btn-spinner {
    background-color: #fff;
    border-color: #3459a7;
    color: #3459a7;
    cursor: default;
  }
  button.default.secondary.disabled:hover,
  button.default.secondary[disabled]:hover,
  button.default.secondary.btn-spinner:hover,
  .xds-button.default.secondary.disabled:hover,
  .xds-button.default.secondary[disabled]:hover,
  .xds-button.default.secondary.btn-spinner:hover {
    background-color: #fff;
    border-color: #3459a7;
    color: #3459a7;
    text-decoration: none;
  }
  button.default.secondary.disabled:hover .xds-icon,
  button.default.secondary[disabled]:hover .xds-icon,
  button.default.secondary.btn-spinner:hover .xds-icon,
  .xds-button.default.secondary.disabled:hover .xds-icon,
  .xds-button.default.secondary[disabled]:hover .xds-icon,
  .xds-button.default.secondary.btn-spinner:hover .xds-icon {
    color: #3459a7;
  }
  button.default.secondary.inverse,
  .xds-button.default.secondary.inverse {
    color: #fff;
    background-color: transparent;
    border-color: #fff;
  }
  button.default.secondary.inverse:hover,
  .xds-button.default.secondary.inverse:hover {
    color: #fff;
    background-color: #486ab0;
    border-color: #486ab0;
  }
  button.regressive,
  .xds-button.regressive {
    background-color: #515252;
    border-color: #515252;
    color: #fff;
  }
  button.regressive:hover,
  .xds-button.regressive:hover {
    background-color: #313131;
    border-color: #313131;
    color: #fff;
    text-decoration: none;
  }
  button.regressive.disabled,
  button.regressive[disabled],
  button.regressive.btn-spinner,
  .xds-button.regressive.disabled,
  .xds-button.regressive[disabled],
  .xds-button.regressive.btn-spinner {
    background-color: #515252;
    border-color: #515252;
    color: #fff;
  }
  button.regressive.secondary,
  .xds-button.regressive.secondary {
    background-color: #fff;
    border-color: #515252;
    color: #515252;
  }
  button.regressive.secondary .xds-icon,
  .xds-button.regressive.secondary .xds-icon {
    color: #515252;
  }
  button.regressive.secondary:hover,
  .xds-button.regressive.secondary:hover {
    background-color: #313131;
    border-color: #313131;
    color: #fff;
    text-decoration: none;
  }
  button.regressive.secondary:hover .xds-icon,
  .xds-button.regressive.secondary:hover .xds-icon {
    color: #fff;
  }
  button.regressive.secondary.disabled,
  button.regressive.secondary[disabled],
  button.regressive.secondary.btn-spinner,
  .xds-button.regressive.secondary.disabled,
  .xds-button.regressive.secondary[disabled],
  .xds-button.regressive.secondary.btn-spinner {
    background-color: #fff;
    border-color: #515252;
    color: #515252;
  }
  button.regressive.secondary.disabled:hover,
  button.regressive.secondary[disabled]:hover,
  button.regressive.secondary.btn-spinner:hover,
  .xds-button.regressive.secondary.disabled:hover,
  .xds-button.regressive.secondary[disabled]:hover,
  .xds-button.regressive.secondary.btn-spinner:hover {
    background-color: #fff;
    border-color: #515252;
    color: #515252;
    text-decoration: none;
  }
  button.regressive.secondary.disabled:hover .xds-icon,
  button.regressive.secondary[disabled]:hover .xds-icon,
  button.regressive.secondary.btn-spinner:hover .xds-icon,
  .xds-button.regressive.secondary.disabled:hover .xds-icon,
  .xds-button.regressive.secondary[disabled]:hover .xds-icon,
  .xds-button.regressive.secondary.btn-spinner:hover .xds-icon {
    color: #515252;
  }
  button.destructive,
  .xds-button.destructive {
    background-color: #cc2427;
    border-color: #cc2427;
    color: #fff;
  }
  button.destructive:hover,
  .xds-button.destructive:hover {
    background-color: #7a1617;
    border-color: #7a1617;
    color: #fff;
    text-decoration: none;
  }
  button.destructive.disabled,
  button.destructive[disabled],
  button.destructive.btn-spinner,
  .xds-button.destructive.disabled,
  .xds-button.destructive[disabled],
  .xds-button.destructive.btn-spinner {
    background-color: #cc2427;
    border-color: #cc2427;
    color: #fff;
  }
  button.compact,
  .xds-button.compact {
    font-size: 0.875rem;
    padding: 0.25rem 0.75rem;
  }
  button.text-only,
  .xds-button.text-only {
    background-color: transparent;
    border-color: transparent;
    color: #3459a7;
  }
  button.text-only:hover,
  .xds-button.text-only:hover {
    color: #1f3564;
    border-color: #1f3564;
  }
  button.text-only:hover .xds-icon,
  .xds-button.text-only:hover .xds-icon {
    color: #1f3564;
  }
  button.text-only.disabled,
  button.text-only[disabled],
  button.text-only.btn-spinner,
  .xds-button.text-only.disabled,
  .xds-button.text-only[disabled],
  .xds-button.text-only.btn-spinner {
    background-color: transparent;
    border-color: transparent;
    color: #3459a7;
  }
  button.text-only .xds-icon,
  .xds-button.text-only .xds-icon {
    color: #3459a7;
  }
  button.text-only.inverse,
  .xds-button.text-only.inverse {
    color: #33cdea;
    background-color: transparent;
  }
  button.text-only.inverse .xds-icon,
  button.text-only.inverse .xds-icon,
  .xds-button.text-only.inverse .xds-icon,
  .xds-button.text-only.inverse .xds-icon {
    color: #33cdea;
  }
  button.text-only.inverse:hover,
  .xds-button.text-only.inverse:hover {
    color: #85e1f2;
    border-color: #85e1f2;
  }

  button.text-only.inverse:hover .xds-icon,
  button.text-only.inverse:hover .xds-icon,
  .xds-button.text-only.inverse:hover .xds-icon,
  .xds-button.text-only.inverse:hover .xds-icon {
    color: #85e1f2;
  }

  @supports (display: grid) {
  }
`;
